module.exports = __webpack_public_path__ + "static/media/externalLinkIconBlue.8f2fddf7.svg";